<div
  *ngIf="
    countriesService &&
    countriesService.countryCodeGlobal &&
    countries.length > 0
  "
  [hidden]="urlNow(window.location.href)">
  <button
    [disabled]="disabledChangeCountry"
    #selectIdentificationCountry
    type="button"
    class="btn btn-info dropdown-toggle ubicacion"
    name="button"
    data-toggle="dropdown">
    <i
      class="flag flag-{{
        countriesService.countryCodeGlobal
          ? countriesService.countryCodeGlobal.toLowerCase()
          : 'im'
      }}"></i>
    {{
      countriesService.countryCodeGlobal
        ? '[' + countriesService.countryCodeGlobal.toUpperCase() + '] '
        : '--'
    }}
    <i class="fa fa-angle-down"></i>
  </button>
  <ul
    class="dropdown-menu ubicacion-menu"
    *ngIf="countries && countries.length > 0">
    <li
      role="presentation"
      [class.active]="
        i.isoCode?.toUpperCase() ==
        countriesService.countryCodeGlobal?.toUpperCase()
      "
      *ngFor="let i of countries">
      <a (click)="selectCountry(i)" role="menuitem" tabindex="-1">
        <i
          class="flag flag-{{
            i.isoCode ? i.isoCode.toLowerCase() : 'im'
          }}"></i>
        [{{ i.isoCode?.toUpperCase() }}] {{ i.name }}
      </a>
    </li>
  </ul>
</div>
